import React, { Component } from 'react';
import Select from 'react-select'

import { isEmpty } from 'lodash';
import PopUp from '../../../../commonModules/interface/PopUp';
import FormCommercialRea from './FormCommercialRea';
import Spin from '../../../../commonModules/interface/Spin';
import { TableRow, TableCell, IconButton, Table, TableBody } from '@material-ui/core';
import { CloseRounded } from '@material-ui/icons';
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { TableLayout } from '../containers/Layout';
import ProductLineCell from '../containers/ProductLineCell';
import { toast } from 'react-toastify';
import { generateUniqueId } from '../../../../commonModules/utils/statsFunctions';

const initErrors = {
    shop_id: "",
    commercial_id: "",
    products:[
        {
            product_id:"",
            quantity:"",
        }
    ],
}

const initSale = {
    shop_id: "",
    shopDisplay:{},
    commercial_id: "",
    commercialDisplay:{},
    transport: "",
    products:[
        {
            display:{value:"", label:""},
            product_id:"",
            quantity:"",
            max:"",
            stock_id:"",
        }
    ],
}

class Form extends Component {
    state = { 
        rea: initSale,
        errors: initErrors,
        view: "rea",
        numberProd:1,
        unique_id: generateUniqueId(),
        sending: false,
        form: <div></div>  // Liste des produits
    }
    
    handleSelect = (option, name) => { 
        // console.log("SELECT HANDLE",{option, name});

        let value = option.value
        let displayName = name === "shop_id" ? "shopDisplay" : "commercialDisplay"
        // console.log("change shop");
        if (name == "shop_id"){
            this.setState({
                ...this.state,
                rea:{
                    ...this.state.rea,
                    [name]:value,
                    [displayName]:option,
                    products:[ // reset products array to prevent stock errors
                        {
                            display:{value:"", label:""},
                            product_id:"",
                            quantity:"",
                            max:"",
                            stock_id:"",
                        }
                    ],
                },
                numberProd:1
            }, () =>{
                // Organise la visualisation des produits
                this.createAddForm()
            }) 

        } else {
            this.setState({
                ...this.state,
                rea:{
                    ...this.state.rea,
                    [name]:value,
                    [displayName]:option,
                },
            }, () =>{
                // Organise la visualisation des produits
                this.createAddForm()
            }) 
        }
           
    }
    handleSelectProducts = (option, index) => {
        // console.log("SELECT HANDLE",{option, index});

        let value = option.value
        const shop = this.state.rea.shop_id
        const max = this.findMax(value, shop)    

        let cpProducts = this.state.rea.products
        cpProducts[index].product_id = value
        cpProducts[index].max = max[0]
        cpProducts[index].stock_id = max[1]
        cpProducts[index].display = option
        
        this.setState({
            ...this.state,
            rea:{
                ...this.state.rea,
                products:cpProducts,
            }
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        })         
    }

    findMax = (product_id, shop_id, list = this.props.AVAILABLE) => { // return available stock and it's id
        const { PRODUCTS } = this.props
        let max = 0
        let stock_id = ""
        Object.keys(list).map( ID => {            
        if(list[ID].product_id === product_id  && list[ID].shop_id === shop_id ){    
            max = list[ID].quantity
            stock_id = ID
            return                    
        }
        })   
        // console.log("findMax", max,);
        return [max, stock_id]
        // return [max, stock_id, reducMax, priceU]
    }
    
    createProductList = () => {
        // console.log("CREATE PRODUCT LIST");
        const list = [{value:"", label:"Chosissez un Produit"}]
        const  { AVAILABLE, PRODUCTS } = this.props
        if(AVAILABLE){
            Object.keys(AVAILABLE).map( ID => {   
                let selected = false
                this.state.rea.products.map( prod => {   
                    if(prod.product_id  === AVAILABLE[ID].product_id)   {  // already selected   
                        selected = true 
                    } 
                })
                if(AVAILABLE[ID].shop_id === this.state.rea.shop_id && AVAILABLE[ID].quantity > 0){
                    list.push (       
                        {value:AVAILABLE[ID].product_id, 
                        label:`${PRODUCTS[ AVAILABLE[ID].product_id ].marque} - ${PRODUCTS[ AVAILABLE[ID].product_id ].name}`, 
                        disabled:selected} 
                    )
                }
            })
        }
        return list
    }
    createAddForm = () => {
        const tab = []
        const products = this.createProductList()

        for (let i = 0; i < this.state.numberProd;i++) {
            
            tab.push(
                <TableRow key={i}>             
                    <ProductLineCell
                        numberProd={this.state.numberProd}
                        handleDeleteProd={() => this.handleDeleteProd(i)}
                        options={products}
                        value={this.state.rea.products[i].display || {value:"", label:""}}
                        onChange={ option => this.handleSelectProducts(option,i)}
                        error={this.state.errors.products[i].product_id}
                    />
                    <TableCell className="text-center" style={{width: "150px"}}>
                        <InputText 
                            type="number" 
                            min={1} 
                            max={this.state.rea.products[i].max} 
                            step={10} 
                            onChange={this.handleChange} 
                            value={this.state.rea.products[i].quantity} 
                            name={"prod_-quantity-"+i} 
                            label="Quantité"
                            helperText={this.state.rea.products[i].max ? "Disponible : "+ this.state.rea.products[i].max :"" }
                            error={this.state.errors.products[i].quantity}
                        />
                    </TableCell>
                    
                </TableRow>                                        
            )
        }
        this.setState({
            ...this.state,
            form:tab,
        })
        return tab;
    }
    handleAddProd = () => {// must add new line in the form to add a product to the rea
        const shop_id = this.state.rea.shop_id
        if (shop_id === ""){
            toast.error("Shop must be selected")
            return
        }
        this.setState({
            ...this.state,
            rea:{
                ...this.state.rea,
                products:[
                    ...this.state.rea.products,{
                    display:{},
                    product_id:"",
                    quantity:"",
                    max:"",
                    stock_id:"",
                }]
            },
            errors:{
                ...this.state.errors,
                products:[
                    ...this.state.errors.products,{                      
                    product_id:"",
                    quantity:"",
                    
                }]
            },
            numberProd:this.state.numberProd+1,
            
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        })    
    }
    handleAddProdByCSV = (productList) =>{
        console.log("Form Rea F  ,handleAddProdByCSV,",productList)
        const productListLocal = new Array();
        const productListLocalErr = new Array();
        const shop_id = this.state.rea.shop_id
        if (shop_id === ""){
            toast.error("Shop must be selected")
            return
        }
        let nbOfProduct = 0;

        productList.forEach((value, key)=>{
            console.log("Form Rea F ,handleAddProdByCSV,",value[5],value[4])
            if (!value[4]){
                return
            }
            const max = this.findMax(value[5].id, shop_id)
            const maxProductNumber =  max[0]
            const stock_id = max[1]
               
            if (stock_id ==="" || typeof stock_id === "undefined"){
                toast.error( "Produit '"+ value[5].name+ "' pas disponible dans le magasin")
                return
            }
            //Check stock maximal
            if (maxProductNumber<value[2]) {
                toast.error( "Produit '"+ value[5].name+ "' pas de quantite suffisante dans le magasin")
                return
            }
            nbOfProduct++
             const productEntry = {
                display: {value:value[5].id,label:value[0]},
                product_id: value[5].id,
                quantity: value[2],
                max: maxProductNumber,
                stock_id: stock_id,
              };
            const productEntryErr = {                      
                product_id:"",
                quantity:"",
            };
            productListLocal.push(productEntry);
            productListLocalErr.push(productEntryErr);
        })
        console.log("Form Rea ,handleAddProdByCSV,productListLocal",productListLocal)
        if (productListLocal.length > 0){
            console.log("Form Rea ,handleAddProdByCSV,Add product",productListLocal.length)
            this.setState({
                ...this.state,
                rea:{
                    ...this.state.rea,
                    products:[...productListLocal]
                },
                errors:{
                    ...this.state.errors,
                    products:[...productListLocalErr]
                },
                numberProd:nbOfProduct,
            }, () =>{
                this.createAddForm()
            })  
        }
        toast.info( "Importation réussi de "+nbOfProduct+" produits")
    }
    handleDeleteProd = (index) => {
        this.setState({
            ...this.state,
            rea:{
                ...this.state.rea,
                products:[
                    ...this.state.rea.products.slice(0,index),
                    ...this.state.rea.products.slice(index +1),
                ]
            },
            errors:{
                ...this.state.errors,
                products:[
                    ...this.state.errors.products.slice(0,index),
                    ...this.state.errors.products.slice(index +1),   
                ]
            },
            numberProd:this.state.numberProd - 1,
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        })    
    }
    handleChange = (e) => {  
        const field = e.target.name
        const value = e.target.value
        const regex = /^[0-9\b]+$/ // int only
        
        if(field.startsWith("prod_")){
            // field = "prod_-quantity-4" || "prod_-product_id-4"

            let splitTab = field.split("-")
            let name = splitTab[1]
            let index = splitTab[2]
            // console.log("[INFO] INDEX field", splitTab, splitTab[0], splitTab[1]);

            let cpProducts = this.state.rea.products
            cpProducts[index][name] = value
            if(name === "quantity" ) {   
                if(value === "" || regex.test(value)){// update value only if its a int
                this.setState({
                        ...this.state,
                        rea:{
                            ...this.state.rea,
                            products:cpProducts,
                        }
                    }, () =>{
                        // Organise la visualisation des produits
                        this.createAddForm()
                    }) 
                }
                
            } else {
                this.setState({
                    ...this.state,
                    rea:{
                        ...this.state.rea,
                        products:cpProducts,
                    }
                }, () =>{
                    // Organise la visualisation des produits
                    this.createAddForm()
                }) 
            }
                    
        } else {
            this.setState({
                ...this.state,
                rea:{
                    ...this.state.rea,
                    [field]:value
                }
            }, () =>{
                // Organise la visualisation des produits
                this.createAddForm()
            }) 
        }
    }
    validate = () => {
        let noErrors = true
        let errors = this.state.errors

        const rea = Object.assign({}, this.state.rea)
        Object.keys(rea).map( field => {
            console.log(field);
            
            if( isEmpty(rea[field]) && !rea[field] && field !== "transport") {// input is empty  
                noErrors = false
                errors[field] = "Veuillez remplir ce champ"
                    
            } else if(field === "products") {
                rea.products.map( (item, j) => {
                    Object.keys(item).map( field2 => { // field2 product_id || quantity
                        
                        if(field2 === "max" ){
                            errors.products[j][field2] = ""
                        } else if(item[field2] === "" || item[field2] === 0 || item[field2] === "0"){
                            noErrors = false
                            errors.products[j][field2] = "Veuillez remplir ce champ"
                        } else if(parseInt(item.max) < parseInt(item.quantity)){
                            noErrors = false
                            errors.products[j].quantity = "Stock insuffisant"
                        } else {
                            errors.products[j][field2] = ""
                        }
                    })
                })

            } else {// not empty
                errors[field] = ""   
            }
        })
        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        this.setState({
            ...this.state,
            errors : errors
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        }) 
        if(noErrors){
            this.setState({
                view: "confirm"
                // view : "client"
            })
        } else {// !VALIDATE
            toast.error( "Le formulaire contient des erreurs")
        }
        
        // return noErrors
    }


    handleSubmit = async () => {
        let newRea = Object.assign({}, this.state.rea)
        this.setState({
            sending: true,
        })
        // rea.id = ""
        // newRea.date = new Date()
        newRea.transport =  parseFloat(newRea.transport)
        newRea.nature =  "commercial"
        newRea.unique_id =  this.state.unique_id

        for (let i = 0; i < newRea.products.length; i++){
            newRea.products[i].quantity = parseInt(newRea.products[i].quantity)                      
        }
        console.log('====================================');
        console.log({newRea});
        console.log('====================================');
        await this.props.createCommercialRea(newRea)
            
        if(this.props.STATE.commercialReas.error){
            console.log("ERROR", this.props.STATE.commercialReas.error);
            this.setState({
                sending: false,
            })
            toast.error( this.props.STATE.commercialReas.error)
        } else {
            //success 
            this.setState({
                sending: false,
            })
            toast.info("Opération enregistrée avec succès")
            this.clearForms()                        
            this.props.handleClose()
        }                
    }
    clearForms = () => {
        this.setState({
            numberProd:1,
            
            rea:initSale,
            errors:initErrors,
        }, () =>{
            // Organise la visualisation des produits
            this.createAddForm()
        }) 
    }

    render() {
        const { view } = this.state;
        console.log("[STATE] NEW REA FORM ",this.state.rea);

        const fieldList = [
            {name: "shop_id", label:"Shop", display:this.state.rea.shopDisplay.label},
            {name: "transport", label:"Transport", display:this.state.rea.transport},
            {name: "commercial_id", label:"Commercial", display:this.state.rea.commercialDisplay.label},
            {name: "products"},   
            // {name: "total", label:"Montant Total", display:this.state.rea.total},
        ]
        
        // const submit = (
        //     <button className="confirm btn btn-lg btn-primary" 
        //     style={{ display: "inline-block" }} 
        //     onClick={this.handleSubmit}
        //     >
        //         Valider
        //     </button>
        // )        
        
        return (
            <React.Fragment>
                {this.props.STATE.commercialReas.fetching && <Spin />}

                {view === "rea" &&
                    <div>
                        <h5>Formulaire Reappro Commercial</h5>
                        <FormCommercialRea 
                            {...this.state} 
                            {...this.props} 
                            handleSelect={this.handleSelect}
                            createAddForm={this.state.form}
                            handleAddProd={this.handleAddProd}
                            handleAddProdByCSV={this.handleAddProdByCSV}
                            handleChange={this.handleChange}
                            validate={this.validate}
                            handleClose={this.props.handleClose}
                        />
                    </div>
                }
                
                {view === "confirm" &&
                <PopUp 
                    title="Résumé" 
                    close={() => this.setState({view: "rea"})}
                    submitAction={this.handleSubmit}
                    submitTitle="Valider"
                    disabledSubmit={ this.state.sending}
                >
                    <TableLayout>
                        <Table>
                            <TableBody>
                                {fieldList.map( field => {
                                    if(this.state.rea[field.name]){
                                        if (field.name === "products"){
                                            return this.state.rea.products.map( prod => (
                                                <TableRow key={prod.product_id}>
                                                    <TableCell component="th">{prod.display.label}</TableCell>
                                                    <TableCell>{prod.quantity}</TableCell>
                                                </TableRow>
                                            ))
                                        } else {
                                            return (
                                                <TableRow key={field.label} >
                                                    <TableCell component="th">{field.label}</TableCell>
                                                    <TableCell colSpan={3}>{field.display}</TableCell>
                                                </TableRow>
                                            )
                                        }
                                    } 
                                })

                                }     
                            </TableBody>
                        </Table>
                    </TableLayout>
                    
                </PopUp>
                }
            </React.Fragment>
        );
    }
}

export default Form;